import { createSelector } from '@reduxjs/toolkit';

const selectHierarchy = (entities) => entities.hierarchy;

export const selectIsListFetching = createSelector(
  [selectHierarchy, (entities, type) => type],
  (hierarchy, type) => hierarchy[`isFetching${type}`],
);

export const selectDesigns = (entities) => entities.hierarchy.list.design.data;
